/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Doc_Lot_LabelInputs */

const vi_print_admin_doc_lot_label = /** @type {(inputs: Print_Admin_Doc_Lot_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem lô`)
};

/**

* @param {Print_Admin_Doc_Lot_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_doc_lot_label = /** @type {((inputs?: Print_Admin_Doc_Lot_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Doc_Lot_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_doc_lot_label(inputs)
});